export const BasicInfoGuestComponent = {
    template: `
        <oo-card>
            <oo-card-header>Contact Information</oo-card-header>
            <oo-card-body>
                <fieldset>
                    <div class="flex-row expand">
                        <add-basic-info></add-basic-info>
                        <p class="disclaimer column column-md-12 column-sm-12" c-type="body-sm-secondary" ng-if="$ctrl.isLoyaltyEnabled">
                            To earn loyalty rewards, please use the email associated with your loyalty account.
                        </p>
                        <div class="error-message" ng-if="$ctrl.errorMessage">{{$ctrl.authenticationService.errorMessage}}</div>
                    </div>
                </fieldset>
            </oo-card-body>
        </oo-card>
    `,
    controller: class {
        constructor(basicInfoService, orderInfoService, restaurantInfoFactory) {
            'ngInject';
            this.basicInfoService = basicInfoService;
            this.orderInfoService = orderInfoService;
            this.restaurantInfoFactory = restaurantInfoFactory;
            this.isLoyaltyEnabled = false;
        }

        $onInit() {
            this.basicInfoService.setBasicInfo(this.orderInfoService.getCustomer());
            this.restaurantInfoFactory.getInfo(['general'])
                .then(data => this.isLoyaltyEnabled = data.general.isLoyaltyEnabled);
        }
    }
};
